import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigateService } from '../../service/navigate.service';
import { PersonService } from '../../service/person.service';
import { ProDevService } from '../../service/pro-dev.service';

@Component({
    selector: 'app-webinar-detail',
    templateUrl: './webinar-detail.component.html',
    styleUrls: ['./webinar-detail.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class WebinarDetailComponent implements OnInit{
    modal: any = {
        title: 'CHINAICAC MEMBER SIGN IN',
        isSigninShow: false,
    };
    userInfo: any; // 用户信息（判断是会员还是游客）

    videoId: number;
    videoInfo: VideoInfoModel = new VideoInfoModel();
    identity: string = '';      // 留言者身份
    identityList: any = ['Student', 'Parent', 'Counselor', 'AO', 'Others'];
    comment: string = '';       // 留言
    commentList: any = [];      // 留言列表
    commentErrMsg: string = ''; // 留言报错信息
    page: any = {
        pageIndex: 1,
        pageCount: 1,
    };
    canReply: boolean = false;  // 是否可回复留言

    swiper: any;

    constructor(
        private route: ActivatedRoute,
        private navigateService: NavigateService,
        private personService: PersonService,
        private proDevService: ProDevService
    ){
        this.videoId = +this.route.snapshot.paramMap.get('id');
    }

    ngOnInit(){
        this.getUserInfo();
    }

    // 获取用户信息
    getUserInfo(){
        this.personService.getUserInfo().subscribe(res => {
            if (res.ok){
                this.userInfo = res.data;
            }
            this.getVideoDetail();
            this.getVideoComment();
        });
    }

    // 获取视频详情
    getVideoDetail(){
        this.proDevService.getVideoDetail(this.videoId).subscribe(res => {
            if (res.code === 200){
                this.videoInfo = new VideoInfoModel(res.data);
                if (this.videoInfo.role === 1 && !this.userInfo) this.modal.isSigninShow = true;
                if (this.userInfo){
                    this.canReply = this.videoInfo.tutorList.some((item: any) => item.teacherId === this.userInfo.userId);
                }
                setTimeout(() => this.initSwiper(), 0);
            }
        });
    }
    // 初始化swiper
    initSwiper() {
        this.swiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            grabCursor: true,
            freeMode: true,
            prevButton:'.swiper-button-prev',
            nextButton:'.swiper-button-next',
        });
    }

    // 获取视频留言
    getVideoComment(pageIndex = 1){
        this.page.pageIndex = pageIndex;
        this.proDevService.getVideoComment(this.videoId, pageIndex).subscribe(res => {
            if (res.status === 200){
                if (res.rows && res.rows[0]){
                    this.commentList = res.rows.map((item: any) => ({
                        ...item,
                        showReplyInput: false,  // 是否显示回复留言框
                        reply: '',              // 回复内容
                    }));
                }
                this.page.pageCount = Math.ceil(res.total / 10);
            }
        });
    }

    // PPT 下载
    fileDownload(path: string){
        window.open(path);
    }

    // 留言
    submitComment(){
        let params = {
            comments: this.comment,
            videoSpeechId: this.videoId,
        };
        if (!this.userInfo) params['userRole'] = this.identity;
        this.comment = '';
        this.identity = '';
        this.proDevService.comment(params).subscribe(res => {
            if (res.ok){
                this.getVideoComment();
            }else{
                this.commentErrMsg = res.msg;
            }
        });
    }

    // 回复留言
    submitReply(comment: any){
        this.proDevService.replyComment({
            parentId: comment.id,
            comments: comment.reply,
        }).subscribe(res => {
            if (res.ok){
                this.getVideoComment(this.page.pageIndex);
            }else{
                console.log(res.msg);
            }
        });
    }

    // 登录弹窗关闭
    onConfirm(){
        this.modal.isSigninShow = false;
        this.navigateService.popRoute();
    }
}

class VideoInfoModel{
    videoName: string;
    publishTime: string;
    videoPath: string;
    tutorList: any;
    videoCover: string;
    showVideoCover: boolean = location.href.includes('webinar');
    files: any;
    role: number; // 视频权限: 1 会员专属，2 不限制

    constructor(data?: any){
        if (data){
            this.videoName = data.videoName;
            this.publishTime = data.publishTime;
            this.videoPath = data.videoPath || '';
            this.tutorList = data.teachers || [];
            this.videoCover = data.videoCover || '';
            this.files = data.files ? eval(data.files) : [];
            this.role = +data.role;
        }
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/professional-dev/webinar-detail/webinar-detail.component.ts